import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { getEnv } from './utils/env';

let authToken: string | null = null;

export function setGraphqlAuthToken(token: string) {
  authToken = token;
}

const authLink = new ApolloLink((operation, forward) => {
  if (authToken) {
    operation.setContext({
      headers: { authorization: `Bearer ${authToken}` },
    });
  }
  return forward(operation);
});

const httpLink = new HttpLink({
  uri: () => getEnv('RONAN_GRAPHQL_GATEWAY_URL'),
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: { fetchPolicy: 'no-cache' },
    watchQuery: { fetchPolicy: 'no-cache' },
  },
});
